import api from "./api";

// Capa de servicios API del dominio "grupos de etiquetas" (tag-groups) (FSD / capa API transversal).
// Wrappers de transporte finos: la construcción de payloads/params vive en el
// componente; aquí solo se centraliza el endpoint (un único lugar que tocar si cambia).

export const listTagGroups = () => api.get("/tag-groups");
export const createTagGroup = (payload) => api.post("/tag-groups", payload);
export const renameTagGroup = (groupId, payload) =>
  api.put(`/tag-groups/${groupId}/rename`, payload);
export const toggleTagGroupKanban = (groupId) =>
  api.put(`/tag-groups/${groupId}/kanban`);
export const deleteTagGroup = (groupId) => api.delete(`/tag-groups/${groupId}`);

// 0391 F4: personalizar un carril del tablero de Agenda (nombre, visibilidad, orden).
// La preferencia sobrevive a "Recrear Kanban".
export const saveKanbanColumnPref = (tagId, payload) =>
  api.put(`/tag-groups/columns/${tagId}`, payload);

// Nuevo orden completo de los carriles: se envía entero para no dejar posiciones
// duplicadas a medio camino si alguien recarga durante el reordenado.
export const reorderKanbanColumns = (tagIds) =>
  api.put("/tag-groups/columns/reorder", { tagIds });
